<template>
<div v-show="visible">
    <transition name="fade">
        <div>
            <a
                href="https://www.insel-sylt.de/gezeitenkalender/"
                target="blank">
                <img class="md:hidden" src="/assets/frontend/svg/tide_widget_small.svg" alt="">
                <img class="hidden md:block" src="/assets/frontend/svg/tide_widget.svg" alt="">
            </a>

            <div
                class="absolute opacity-75 p-3 right-0 bottom-0 rotate-45 transform rounded-full cursor-pointer mr-4 lg:mr-10"
                @click="hide">
                <img src="/assets/frontend/svg/icon_plus.svg" alt="">
            </div>
            
        </div>
    </transition>
</div>
</template>

<script>
export default {
    name: 'widget-tide',
    props: ['initialVisible'],

    data: () => ({
        visible: false,
    }),

    watch: {
        visible() {
            this.$emit('visiblity-changed', this.visible);
        }
    },

    mounted() {
        if(this.initialVisible != '') {
            this.visible = this.initialVisible;
        }
    },

    methods: {
       show() {
           this.visible = true;
       },

       hide() {
           this.visible = false;
       },

       toggle() {
           this.visible = !this.visible;
       }
    }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
